import React from 'react';
import Navigation from '../components/Navigation';
import { Award, Heart, Users, Calendar } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-teal-50 to-cyan-50 pt-32 pb-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Meet Me</h1>
          <p className="text-xl text-gray-600">Qualified Massage Therapist • Rugby, Warwickshire</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="flex flex-col md:flex-row gap-12 items-center mb-16">
          
          {/* Intro Text */}
          <div className="flex-1">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Welcome to Hollis Massage</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              For many years, I've been passionate about massage therapy, attending workshops and evening classes to develop my skills and knowledge. This has led me to achieve professional qualifications that allow me to offer you the highest standard of care.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              By day, I work as a full-time computer programmer, but I absolutely love the contrast between sitting at a computer all day and being on my feet, talking to people, and hopefully being able to offer some help and relief.
            </p>
          </div>
        </div>

        {/* Qualifications Section */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 mb-16">
          <div className="flex items-center space-x-3 mb-6">
            <Award className="text-teal-600" size={32} />
            <h2 className="text-3xl font-bold text-gray-900">Professional Qualifications</h2>
          </div>
          
          <div className="space-y-6">
            {/* Qualification 1 */}
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="bg-teal-100 rounded-full p-3 flex-shrink-0">
                  <Award className="text-teal-600" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Diploma - Level 3 Certificate in Swedish Massage
                  </h3>
                  <p className="text-gray-700 font-medium mb-1">Central School of Massage</p>
                  <p className="text-gray-600 text-sm">Spring 2025</p>
                </div>
              </div>
            </div>

            {/* Qualification 2 */}
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="bg-teal-100 rounded-full p-3 flex-shrink-0">
                  <Award className="text-teal-600" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Manual Lymphatic Drainage
                  </h3>
                  <p className="text-gray-700 font-medium mb-1">Accredited Diploma Course</p>
                  <p className="text-gray-600 text-sm">Gateway Workshops</p>
                </div>
              </div>
            </div>

            {/* Qualification 3 */}
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="bg-teal-100 rounded-full p-3 flex-shrink-0">
                  <Award className="text-teal-600" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Deep Tissue Massage
                  </h3>
                  <p className="text-gray-700 font-medium mb-1">Central School of Massage</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Me Section */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white border-2 border-gray-200 rounded-xl p-8 hover:border-teal-300 transition">
            <div className="bg-teal-100 rounded-full w-16 h-16 flex items-center justify-center mb-4">
              <Heart className="text-teal-600" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Passionate About Helping</h3>
            <p className="text-gray-700">
              I genuinely love what I do. There's nothing more rewarding than helping people feel better and seeing the positive difference massage can make to their wellbeing.
            </p>
          </div>

          <div className="bg-white border-2 border-gray-200 rounded-xl p-8 hover:border-teal-300 transition">
            <div className="bg-teal-100 rounded-full w-16 h-16 flex items-center justify-center mb-4">
              <Users className="text-teal-600" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Understanding Your Needs</h3>
            <p className="text-gray-700">
              As someone who sits at a computer all day, I understand the aches and pains that come with modern life. I tailor each treatment to your individual needs.
            </p>
          </div>
        </div>

        {/* Personal Touch */}
        <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-8 text-white text-center">
          <h2 className="text-3xl font-bold mb-4">The Perfect Balance</h2>
          <p className="text-xl text-teal-50 leading-relaxed max-w-3xl mx-auto">
            My dual career as a programmer and massage therapist gives me a unique perspective. I understand the demands of desk work and the importance of taking care of your body. It's this balance that drives my passion for helping others find relief and relaxation.
          </p>
        </div>
      </div>

      {/* Call to Action */}
      
      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-gray-400">
            &copy; 2025 Hollis Massage. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm mt-2">
            Professional Massage Therapy • Rugby, Warwickshire
          </p>
        </div>
      </footer>
    </div>
  );
}
